import React from "react";

import { Button, InfoModal, useModal } from "@newsela/angelou";
import { actionNames, withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import FormativeGraphicOrganizerButton from "../FormativeGraphicOrganizerButton";
import GraphicOrganizerModalButton from "../GraphicOrganizerModalButton";
import {
  closeButtonCss,
  footerCss,
  modalContentWrapperCss,
  rootCss,
  unorderedListCss,
} from "./GraphicOrganizerModal.style";

const propTypes = {
  contentId: PropTypes.string,
  graphicOrganizers: PropTypes.array,
  title: PropTypes.string,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const GraphicOrganizerModal = ({ contentId, graphicOrganizers, title }) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  const closeButtonEventProperties = {
    actionName: actionNames.cancel,
    streamProperties: {
      description: `Close modal for ${title} graphic organizers`,
      content_id: contentId,
    },
  };

  const renderCloseButton = () => {
    return (
      <ButtonWithTrackEvent
        __cssFor={{ root: closeButtonCss }}
        flavor={Button.flavors.primary}
        onClick={() => setActive(false)}
        triggerRef={triggerRef}
        {...closeButtonEventProperties}
      >
        Done
      </ButtonWithTrackEvent>
    );
  };

  const renderFormativeGraphicOrganizerButtons = () => {
    return (
      <ul css={unorderedListCss}>
        {graphicOrganizers.map((organizer, index) => {
          const formativeDestination =
            organizer["Formative Clone Link"].split("clone/")[1];

          return (
            <li key={index}>
              <FormativeGraphicOrganizerButton
                contentId={contentId}
                formativeDestination={formativeDestination}
                gradeBand={organizer["Grade Band"]}
                imageUrl={organizer["PNG URL"]}
                title={organizer["Graphic Organizer Title"]}
              />
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <GraphicOrganizerModalButton
        contentId={contentId}
        numberOfOrganizers={graphicOrganizers.length}
        setActive={setActive}
        triggerRef={triggerRef}
        title={title}
      />
      <InfoModal
        __cssFor={{
          root: rootCss,
          footer: footerCss,
          modalContentWrapper: modalContentWrapperCss,
        }}
        eyebrow="Graphic organizers"
        footer={renderCloseButton()}
        isMobileTakeover
        labelId="GraphicOrganizers"
        onBackgroundClick={() => {
          setActive(false);
        }}
        title={title}
        {...modalProps}
      >
        {renderFormativeGraphicOrganizerButtons()}
      </InfoModal>
    </>
  );
};

GraphicOrganizerModal.propTypes = propTypes;

export default GraphicOrganizerModal;
